<template>
  <div
    class="map-filter"
    :class="classModifier"
  >
    <div
      v-if="!isTablet && !isMobile"
      class="map-filter__items"
    >
      <div
        v-for="list in paramFilter"
        :key="list.name"
        class="map-filter__item"
      >
        <div class="field-checkbox field-checkbox_switch">
          <input
            :id="list.name"
            v-model="list.value"
            class="field-checkbox__input"
            type="checkbox"
            @change="updateFilterUrl"
          >
          <label
            class="field-checkbox__label"
            :for="list.name"
          >
            <img
              :src="list.img"
              class="map-filter__icon"
            >
            <div class="map-filter__text">
              <p :id="`map-filter__tooltip_${list.name}`">{{ list.label }}</p>
            </div>
          </label>
        </div>
      </div>
      <template v-if="showTooltip">
        <b-tooltip
          target="map-filter__tooltip_reception"
          placement="bottom"
          boundary-padding="0"
          custom-class="tooltip_legend tooltip_legend-receive-branch"
        >
          Вне зависимости от&nbsp;времени передачи заказов отправление происходит на&nbsp;следующий день
        </b-tooltip>
        <b-tooltip
          target="map-filter__tooltip_terminalReception"
          placement="bottom"
          boundary-padding="0"
          custom-class="tooltip_legend tooltip_legend-terminal-branch"
        >
          При передаче груза на&nbsp;терминал, доставка из&nbsp;вашего региона будет осуществляться в&nbsp;сроки, указанные в&nbsp;разделе
          <a
            href="/e-commerce/dokumenty/dokumenty-i-tarify"
            class="map-legend__tooltip-link"
            rel="noopener"
          >Tарифы</a>
        </b-tooltip>
        <b-tooltip
          target="map-filter__tooltip_expressReception"
          placement="bottom"
          boundary-padding="0"
          custom-class="tooltip_legend tooltip_legend-express-branch"
        >
          При передаче посылки до&nbsp;17:00 отправление в&nbsp;этот&nbsp;же день, после 17:00&nbsp;&mdash; на&nbsp;следующий день
        </b-tooltip>
      </template>
    </div>
    <template v-else>
      <div
        v-if="!showFilterInline"
        class="map-nav__button-content"
      >
        <a
          class="map-nav__button map-nav__button_submenu"
          :class="{ 'map-nav__button_active': showFilter }"
          @click="showFilter = !showFilter"
        >
        <span class="map-nav__button-text">
          <svg
            class="filter-icon"
            width="20px"
            height="16px"
          >
            <use xlink:href="#filter" />
          </svg>
          <span class="map-nav__text">
            Подбор отделения
          </span>
          <svg
            v-if="showFilter"
            class="close-icon"
            width="10px"
            height="10px"
          >
            <use xlink:href="#close" />
          </svg>
        </span>
          <div class="map-nav__submenu">
            <div
              v-for="list in paramFilter"
              :key="list.name"
              class="map-nav__submenu-item"
            >
              <div class="field-checkbox field-checkbox_switch">
                <input
                  :id="list.name"
                  v-model="list.value"
                  class="field-checkbox__input"
                  type="checkbox"
                  @change="updateFilterUrl"
                >
                <label
                  class="field-checkbox__label"
                  :for="list.name"
                >{{ list.label }}</label>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div v-else class="">
        <div
          v-for="list in paramFilter"
          :key="list.name"
          class=""
        >
          <div class="field-checkbox field-checkbox_switch">
            <input
              :id="list.name"
              v-model="list.value"
              class="field-checkbox__input"
              type="checkbox"
              @change="updateFilterUrl"
            >
            <label
              class="field-checkbox__label"
              :for="list.name"
            >
              <img
                :src="list.img"
                class="map-filter__icon me-3"
              >
              {{ list.label }}
            </label>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import URL from '../../helpers/url';
import deviceInfo from '../../helpers/device';

export default {
  name: 'BranchFilter',
  props: {
    paramFilter: Array,
    classModifier: {
      type: String,
      default: '',
    },
    selectedCity: Object,
    showTooltip: {
      type: Boolean,
      default: true,
    },
    showFilterInline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showFilter: false,
      query: [],
    };
  },
  computed: {
    ...deviceInfo,
  },
  watch: {
    selectedCity(newVal, oldVal) {
      if (newVal.Code !== oldVal.Code) {
        this.resetFilter();
      }
    },
  },
  mounted() {
    const url = new URL(window.location.href);
    this.paramFilter = url.applyFilterParams(this.paramFilter);
    const searchParams = Object.keys(url.searchParams)[0].includes('http') ? {} : url.searchParams;
    this.query = this.getQuery(searchParams);
    this.updateFilterUrl();
  },
  methods: {
    getFilterQueryParams() {
      const filters = [];
      this.paramFilter.map((filter) => {
        if (!filter.value) {
          filters.push(`${filter.name}=${0}`);
        }
      });
      return filters;
    },
    updateFilterUrl() {
      const queryParams = this.getFilterQueryParams();
      this.$emit('change-filter', this.paramFilter);
      const urlParams = queryParams.length ? `?${queryParams.join('&')}` : window.location.pathname;
      let urlQuery = this.query.length ? `${this.query.join('&')}` : '';
      if (urlQuery) {
        urlQuery = queryParams.length ? `&${urlQuery}` : `?${urlQuery}`;
      }
      window.history.pushState(window.location.origin, null, (urlParams + urlQuery));
    },
    resetFilter() {
      this.paramFilter = this.paramFilter.map((item, key) => {
        this.paramFilter[key].value = true;
        return this.paramFilter[key];
      });
      this.$emit('change-filter', this.paramFilter);
      const urlQuery = this.query.length ? `?${this.query.join('&')}` : '';
      window.history.pushState(window.location.origin, null, window.location.pathname + urlQuery);
    },
    getQuery(searchParams = {}) {
      const query = [];
      const paramFilterName = this.paramFilter.map((paramItem) => paramItem.name);
      Object.keys(searchParams).forEach((searchKey) => {
        if (!paramFilterName.includes(searchKey)) {
          query.push(`${searchKey}=${searchParams[searchKey]}`);
        }
      });
      return query;
    },
  },
};
</script>
<style lang="scss">
@import './BranchFilter.scss';
</style>
